module.exports = __webpack_public_path__ + "img/add.47a3de0e.svg";